import { Flex } from 'theme-ui';

import { useMediaQuery } from '../../helpers/mediaQuery';

import type { ErrorProps } from './types';

export const Error = ({ size, sx, ...rest }: ErrorProps) => {
  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  const isLarge = size === 'large';

  return (
    <Flex
      {...(isLarge
        ? {
            padding: isScreenSm ? 'grid-24' : 'grid-40',
          }
        : {
            paddingTop: 'grid-28',
          })}
      sx={{
        justifyContent: 'center',
        ...sx,
      }}
      {...rest}
    />
  );
};
